import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { mediaDataSelector } from '../../../common/store/selectors/mediaData.selector';
import { playerDataSelector } from '../../../common/store/selectors/playerData.selector';
import { ReplayVideo } from '../replayVideo/replayVideo';
import { VideoControls } from '../videoControls/videoControls';
import { adsDataSelector } from '../../../common/store/selectors/adsData.selector';
import { systemGeneralSelector } from '../../../common/store/selectors/systemGeneral.selector';
import { ErrorBoundary } from '../../../common/components/errorBoundary/errorBoundary';
import { css } from '../../../common/styles/styles.utils';

const CONTROLS_PLUGIN = 'Controls';

interface ControlsContainerProps {
  style: any;
}

const ControlsContainer: FunctionComponent<ControlsContainerProps> = props => {
  const { style } = props;
  const isVastAd = useSelector(adsDataSelector.isVastAd);
  const adBreak = useSelector(adsDataSelector.adBreak);
  const videoList = useSelector(mediaDataSelector.videoList);
  const loadingPlayer = useSelector(playerDataSelector.loadingPlayer);
  const isFatalError = useSelector(systemGeneralSelector.isFatalError);
  const videoTagStatus = useSelector(playerDataSelector.videoTagStatus);

  const showReplayVideo = videoList.length === 1 && videoTagStatus === 'complete';

  const isVpaidShown = !isVastAd && adBreak;
  const hideAllControls = isVpaidShown || loadingPlayer || isFatalError;

  return (
    <div style={css(style)}>
      <ErrorBoundary pluginName={CONTROLS_PLUGIN}>
        {
          showReplayVideo
            ? <ReplayVideo />
            : <VideoControls hideAllControls={hideAllControls} />
        }
      </ErrorBoundary>
    </div>
  );
};

export default ControlsContainer;
